export const CHECKBOX = 'checkbox';
export const RADIO = 'radio';
export const FILE = 'file';

// allowed formats : +33 X XX XX XX XX, XX XX XX XX XX, 0033 X XX XX XX XX
export const PHONENUMBER_REGEX = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/;
export const DATE_REGEX = /^\d{1,2}\/\d{1,2}\/\d{4}$/i;
export const PASSWORD_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{4,}$/i;
export const PASSWORD_MINLENGTH = 6;
export const PASSWORD_MAXLENGTH = 100;
export const BIC_REGEX = /^[A-Z0-9]{8,}$/i;



// WEBPACK FOOTER //
// ./src/components/form/constants.js